/** Used by event handlers to prevent default event behaviour. */
type UnknownEvent = { preventDefault(): void };
export const preventDefault = (e: UnknownEvent): void => e.preventDefault();
